import FeaturedMap from "./FeaturedMap";

export * from "./context";
export { useDeckOverlays } from "./deck/DeckOverlaysContext";
export { DeckOverlayType, DeckSlot } from "./deck/DeckSlot";
export { default as useDeckLayers } from "./deck/useDeckLayers";
export type { FeaturedMapProps } from "./FeaturedMap";
export { default as MapContent } from "./MapContent";

export * from "@app/component/map/core/controls";
// Curated re-exports of commonly-paired building blocks (public API)
export * from "@app/component/map/core/features";
export { default as OverlayView } from "@app/component/map/core/primitives/OverlayView";
export { default as UserLocation } from "@app/component/map/core/primitives/UserLocation";

export * from "@app/component/map/FeaturedMap/types";
export default FeaturedMap;
